




import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { ScreenOrientation } from '@/resources/enum/ScreenOrientation';

@Component
export default class ScreenOrientationTracker extends Vue {
  private currentOrientation: ScreenOrientation = ScreenOrientation.None;

  @Emit()
  private initialized(value: ScreenOrientation) {}

  @Emit()
  private orientationChanged(value: ScreenOrientation) {}

  @Watch('currentOrientation')
  private onOrientationChanged() {
    this.orientationChanged(this.currentOrientation);
  }

  private getCurrentOrientation(): ScreenOrientation {
    if (this.$store.getters['camera/isPC']) return ScreenOrientation.None;

    if (screen.orientation && screen.orientation.type) {
      switch (screen.orientation.type) {
        case 'portrait-primary':
        case 'portrait-secondary':
          return ScreenOrientation.Portrait;

        case 'landscape-primary':
        case 'landscape-secondary':
          return ScreenOrientation.Landscape;

        default:
          throw new Error('Invalid screen orientation');
      }
    } else {
      const orientation = window.orientation;
      return orientation === 0 ? ScreenOrientation.Portrait : ScreenOrientation.Landscape;
    }
  }

  private setCurrentOrientation() {
    this.currentOrientation = this.getCurrentOrientation();
  }

  created() {
    this.setCurrentOrientation();
    window.addEventListener('orientationchange', this.setCurrentOrientation);

    // Chrome for Android: 画面スリープ (電源ボタン押下など) -> 画面向き変更 -> 画面復帰 というプロセスだと
    // orientationchange イベントが発火しないため resize イベントに処理を追加
    window.addEventListener('resize', this.setCurrentOrientation);
    this.initialized(this.currentOrientation);
  }

  beforeDestroy() {
    window.removeEventListener('orientationchange', this.setCurrentOrientation);
    window.removeEventListener('resize', this.setCurrentOrientation);
  }
}
